import { DateFields, SearchCriteria } from '@/src/types/itinerary'
import dayjs from 'dayjs'
import { dateFields } from './travelerDocumentToInputsSegregater'

export const isNextDay = (departureDateTime: string, arrivalDateTime: string): boolean => {
    const departureDay = dayjs(departureDateTime).format('YYYY-MM-DD')
    const arrivalDay = dayjs(arrivalDateTime).format('YYYY-MM-DD')
    return departureDay !== arrivalDay
}

/**
 * Converts ISO date string to day/month/year object
 * @param isoDateString - ISO date string (e.g., "2032-06-06T00:00:00.000+0000")
 * @returns Object with day, month, and year properties
 */
export const isoStringToDateObject = (isoDateString: string): DateFields => {
    if (!isoDateString) return { day: '', month: '', year: '' }
    const date = dayjs(isoDateString)

    return {
        day: date.date().toString(),
        month: dateFields.months[date.month()], // dayjs months are 0-indexed
        year: date.year().toString()
    }
}

/**
 * Converts day/month/year object to ISO date string
 * @param dateObject - Object with day, month, and year properties
 * @returns ISO date string
 */
export const dateObjectToIsoString = (dateObject: DateFields): string => {
    const { day, month, year } = dateObject
    const monthIndex = dateFields.months.indexOf(month)

    return dayjs()
        .year(parseInt(year))
        .month(monthIndex) // dayjs months are 0-indexed
        .date(parseInt(day))
        .startOf('day')
        .toISOString()
}
